import { MAX_BUNDLE_SIZE } from "../../../constants";

export default {
  allAccessBulletOne:
    "Unlock read-only access to all forums in the Rivals network",
  allAccessBulletTwo:
    "Go behind enemy lines to see what ll your rivals are saying about your school",
  allAccessRadioLabel: (price: string): string =>
    `Get All Access for ${price} 🤩`,
  allAccessUpsellPromoText: "BEST VALUE",
  bundleBulletPrefix: (price: string): string =>
    `Get read-only access to a bundle of ${MAX_BUNDLE_SIZE} Rivals - only $${price} per school`,
  bundleBulletSuffix: "per school",
  bundleRadioLabelPrefix: "Bundle & Save",
  bundleRadioLabelSuffix: `+ ${MAX_BUNDLE_SIZE - 1} others`,
  bundleUpsellPromo: "Save 20%",
  headerText: "Pick a Spy on Your Rival plan",
  standardRadioLabel: "Spy on "
};
